export default "__VITE_ASSET__B$h6vN1I__"